import { TEAM_MAX_SEATS, TEAM_MIN_SEATS } from './billing-constants'

export function SeatStepper({ seats, onChange, disabled }: { seats: number; onChange: (n: number) => void; disabled: boolean }) {
  function clamp(n: number) {
    if (Number.isNaN(n)) return TEAM_MIN_SEATS
    return Math.max(TEAM_MIN_SEATS, Math.min(TEAM_MAX_SEATS, Math.floor(n)))
  }
  return (
    <div className="mb-4 flex items-center justify-between rounded-lg border border-gray-200 px-3 py-2">
      <span className="text-sm font-medium text-gray-700">Seats</span>
      <div className="flex items-center gap-2">
        <button
          type="button"
          aria-label="Remove seat"
          disabled={disabled || seats <= TEAM_MIN_SEATS}
          onClick={() => onChange(clamp(seats - 1))}
          className="flex h-7 w-7 items-center justify-center rounded-full border border-gray-300 text-lg leading-none text-gray-700 hover:border-gray-900 disabled:cursor-not-allowed disabled:opacity-40"
        >
          −
        </button>
        <input
          type="number"
          min={TEAM_MIN_SEATS}
          max={TEAM_MAX_SEATS}
          value={seats}
          disabled={disabled}
          onChange={(e) => onChange(clamp(Number(e.target.value)))}
          className="w-12 rounded border border-gray-200 px-2 py-1 text-center text-sm tabular-nums focus:border-sky-500 focus:outline-none focus:ring-1 focus:ring-sky-500"
          aria-label="Seat count"
        />
        <button
          type="button"
          aria-label="Add seat"
          disabled={disabled || seats >= TEAM_MAX_SEATS}
          onClick={() => onChange(clamp(seats + 1))}
          className="flex h-7 w-7 items-center justify-center rounded-full border border-gray-300 text-lg leading-none text-gray-700 hover:border-gray-900 disabled:cursor-not-allowed disabled:opacity-40"
        >
          +
        </button>
      </div>
    </div>
  )
}
